const item = Object.freeze({
  NotAvailableInCenter: 37,
});
export default item;
